import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 7AF3BC52-D506-4CCB-A813-A7785CFD6524
 * name information-slab-circle
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-slab-circle.svg
 * tags
 * - Settings 
 */
export const InformationSlabCircleIcon = createSvgIcon(<><path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22M11 7H13V9H11V7M14 17H10V15H11V13H10V11H13V15H14V17Z" /></>, 'InformationSlabCircleIcon');
export default InformationSlabCircleIcon